// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ParentalSettingType } from "../schema";

export function serialize_ParentalSettingType_internal(value: ParentalSettingType): unknown {
  return ((value: "CRUDE_LANGUAGE" | "RELIGIOUS" | "POLITICAL"): unknown => {
    return value;
  })(value);
}
export function serialize_ParentalSettingType(obj: ParentalSettingType): string {
  return renderJsonWithNumbersAsBigint(serialize_ParentalSettingType_internal(obj));
}
export function deserialize_ParentalSettingType_internal(value: unknown): ParserResult<ParentalSettingType> {
  return ((value: unknown): ParserResult<"CRUDE_LANGUAGE" | "RELIGIOUS" | "POLITICAL"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/ParentalSettingType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "CRUDE_LANGUAGE":
        return { success: true, value: "CRUDE_LANGUAGE" };
      case "RELIGIOUS":
        return { success: true, value: "RELIGIOUS" };
      case "POLITICAL":
        return { success: true, value: "POLITICAL" };
      default:
        return { success: false, reason: `[#/components/schemas/ParentalSettingType]: '${value}' expected to be enum, one of 'CRUDE_LANGUAGE, RELIGIOUS, POLITICAL'.` };
    }
  })(value);
}
export function deserialize_ParentalSettingType(str: string): ParserResult<ParentalSettingType> {
  return deserialize_ParentalSettingType_internal(parseJsonWithNumbersAsBigint(str));
}
